import { render, staticRenderFns } from "./CarnivoreWork.vue?vue&type=template&id=715de8bc&"
import script from "./CarnivoreWork.vue?vue&type=script&lang=js&"
export * from "./CarnivoreWork.vue?vue&type=script&lang=js&"
import style0 from "./CarnivoreWork.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports